// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Checkmark-module--bx--text-truncate--end--DB5AV";
export var bxTextTruncateFront = "Checkmark-module--bx--text-truncate--front--3u3u1";
export var drawStroke = "Checkmark-module--drawStroke--_4Owz";
export var path = "Checkmark-module--path--37Wgm";
export var svg = "Checkmark-module--svg--ZCO5t";